import { configureStore } from "@reduxjs/toolkit";
import topologySlice from "../Components/Topology/store/topologySlice";
import globalSlice from "../Components/store/globalSlice";
import dashboardSlice from "../Components/Dashboard/dashboardSlice";
import upgradeSlice from "../Components/DeviceBackup/store/upgradeSlice";
import reportSlice from "Components/Report/reportSlice";
import deviceTableSlice from "Components/Topology/Device/deviceTableSlice";
import settingSlice from "Components/Topology/Setting/settingSlice";
import goSlice from "Components/Go/goSlice";
import logSlice from "Components/Log/logSlice";
import managementSlice from "Components/Management/ManagementSlice";

export const store = configureStore({
    // 將各個模塊的 reducer 包含在這個 store 進行資料管理
  reducer: {
    global: globalSlice.reducer,            // 用戶狀態組件 reducer
    dashboard: dashboardSlice.reducer,      // 儀表板狀態 reducer
    topology: topologySlice.reducer,        // 數據機連線狀態 reducer
    upgrade: upgradeSlice.reducer,          // 升級狀態 reducer
    report: reportSlice.reducer,            // 報告狀態 reducer
    deviceTable: deviceTableSlice.reducer,  // 設備列表狀態 
    management: managementSlice.reducer,    // 管理狀態
    setting: settingSlice.reducer,          // 個人設定狀態 reducer
    goPage: goSlice.reducer,                // 設備設定狀態 reducer
    log: logSlice.reducer,                  // 日誌狀態 reducer
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
